import React from "react";

export const CloseIcon = ({ width = 28, height = 28, className, onClick }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 28 28" fill="none" className={className} onClick={onClick} style={{ cursor: "pointer" }}>
    <mask id="mask0_2841_12764" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="28" height="28">
      <rect width="28" height="28" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_2841_12764)">
      <path d="M9.79996 19.8331L8.16663 18.1997L12.3666 13.9997L8.16663 9.82889L9.79996 8.19556L14 12.3956L18.1708 8.19556L19.8041 9.82889L15.6041 13.9997L19.8041 18.1997L18.1708 19.8331L14 15.6331L9.79996 19.8331Z" fill="#444444"/>
    </g>
  </svg>
);

export const WarningTopIcon = ({ width = 32, height = 32, className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32" fill="none" className={className}>
    <mask id="mask0_2841_12774" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="32" height="32">
      <rect width="32" height="32" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_2841_12774)">
      <path d="M16 20C16.3777 20 16.6944 19.8722 16.95 19.6167C17.2055 19.3611 17.3333 19.0445 17.3333 18.6667C17.3333 18.2889 17.2055 17.9722 16.95 17.7167C16.6944 17.4611 16.3777 17.3334 16 17.3334C15.6222 17.3334 15.3055 17.4611 15.05 17.7167C14.7944 17.9722 14.6666 18.2889 14.6666 18.6667C14.6666 19.0445 14.7944 19.3611 15.05 19.6167C15.3055 19.8722 15.6222 20 16 20ZM14.6666 14.6667H17.3333V6.66669H14.6666V14.6667ZM2.66663 29.3334V5.33335C2.66663 4.60002 2.92774 3.97224 3.44996 3.45002C3.97218 2.9278 4.59996 2.66669 5.33329 2.66669H26.6666C27.4 2.66669 28.0277 2.9278 28.55 3.45002C29.0722 3.97224 29.3333 4.60002 29.3333 5.33335V21.3334C29.3333 22.0667 29.0722 22.6945 28.55 23.2167C28.0277 23.7389 27.4 24 26.6666 24H7.99996L2.66663 29.3334ZM6.86663 21.3334H26.6666V5.33335H5.33329V22.8334L6.86663 21.3334Z" fill="#FFD34D"/>
    </g>
  </svg>
);

export const DropdownCaretIcon = ({ width = 24, height = 24, className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none" className={className}>
    <mask id="mask0_2841_12785" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
      <rect width="24" height="24" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_2841_12785)">
      <path d="M12 15L7 10H17L12 15Z" fill="#666666"/>
    </g>
  </svg>
);

export const DocumentInfoIcon = ({ width = 18, height = 18, className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 18" fill="none" className={className}>
    <mask id="mask0_2847_8202" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
      <rect width="18" height="18" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_2847_8202)">
      <path d="M3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39688 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39688 2.98438 2.69063 2.69063C2.98438 2.39688 3.3375 2.25 3.75 2.25H12L15.75 6V14.25C15.75 14.6625 15.6031 15.0156 15.3094 15.3094C15.0156 15.6031 14.6625 15.75 14.25 15.75H3.75ZM3.75 14.25H14.25V6.75H11.25V3.75H3.75V14.25ZM5.25 12.75H12.75V11.25H5.25V12.75ZM5.25 6.75H9V5.25H5.25V6.75ZM5.25 9.75H12.75V8.25H5.25V9.75Z" fill="#C78D3C"/>
    </g>
  </svg>
);
